export const notificationCenter = {
  markAsRead: "읽음으로 표시",
  activity: "활동",
  read: "읽음",
  unread: "읽지 않음",
};
